export default "__VITE_ASSET__CajJ835Q__"